export const loadedImagesCache = new Set();
